import { useQueryClient } from '@tanstack/react-query';
import { useNotifications } from 'app/utils/hooks';
import { QueryKeys, DarDto } from 'data';
import { Modal } from '../modal';

export const RemoveDarFromParticipantModal = ({
  participantName,
  isRemote,
  fileToRemove,
  removeParticipantDarFn,
  onClose,
  onSettled,
  isLoading,
}: {
  participantName: string;
  isRemote: boolean;
  fileToRemove: DarDto;
  removeParticipantDarFn: (variables: string, { onSuccess, onSettled }) => void;
  onClose: () => void;
  onSettled?: () => void;
  isLoading: boolean;
}) => {
  const queryClient = useQueryClient();
  const { showSuccessMessage } = useNotifications();

  const message = (
    <div>
      DAR file <strong>{fileToRemove.name}</strong> was removed from {isRemote ? 'remote' : ''} participant
    </div>
  );

  const onSubmit = () => {
    removeParticipantDarFn(fileToRemove.hash as string, {
      onSuccess: async () => {
        await queryClient.invalidateQueries([
          isRemote ? QueryKeys.REMOTE_PARTICIPANTS : QueryKeys.PARTICIPANTS,
          participantName,
          'dars',
        ]);
        showSuccessMessage(message);
      },
      onSettled,
    });
  };

  return (
    <Modal
      withConfirm
      onSubmit={onSubmit}
      onClose={onClose}
      title="Remove DAR file?"
      text={`Are you sure you want to remove ${fileToRemove.name} ?`}
      isLoading={isLoading}
      submitButtonProps={{ type: 'button' }}
      submitText="Confirm"
    />
  );
};
